module.exports = __webpack_public_path__ + "static/media/Feasibility_report.46c15c2b.pdf";